import api from "@/api.js";
import data from "./data/";
import woven from "./woven/";
import story from "./story/";

export default {
  namespaced: true,
  modules: {
    data,
    woven,
    story,
  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {},
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  },
};
